import React from 'react';

import Link from '@swf/components/Link/Link';
import { RoutingKey } from '@swf/core/enums';

import type { Category } from '../types';

export const getCategoryTitle = (categories: Category[], currentId: string) =>
  categories?.filter(({ id }) => currentId === id)[0]?.title || '';

export const getSideNavs = (categories: Category[]) =>
  categories?.map(({ id, title }) => ({
    id,
    element: (
      <Link route={RoutingKey.HelpCenterCategoryArticles} values={{ category: id }}>
        {title}
      </Link>
    )
  })) || [];

export const routes = {
  [RoutingKey.Home]: '/',
  [RoutingKey.HelpCenter]: '/help/',
  [RoutingKey.HelpCenterArticle]: '/help/articles/:ref/',
  [RoutingKey.HelpCenterCategoryArticles]: '/help/categories/:category/',
  [RoutingKey.HelpCenterSearchArticles]: '/help/search/:searchTerm/'
};
